export {default} from './Quantity';
